import * as ICONS from "@bracket/react-icons";

import { Fragment, CSSProperties, useState, FunctionComponent, } from "react";
import "./Input.scss";

export declare type InputProps = Omit<
	React.HTMLProps<HTMLInputElement>,
	"onChange"
> & {
	value: string|null;
	onChange?: (s: string) => void;
	placeholder?: string;
	disabled?: boolean;
	isSuccess?: boolean;
	isError?: boolean;
	mt?: string;
	mb?: string;
	ml?: string;
	mr?: string;
	className?: string;
	width?: string;
	icon?: keyof typeof ICONS,
	iconPosition?: "start" | "end";
	iconProps?: any;
};


export const Input = ({
	value,
	onChange = ( ) => { },
	placeholder,
	icon,
	iconPosition = "start",
	iconProps = {},
	disabled,
	isSuccess,
	isError,
	mt = "0",
	mb = "0",
	ml = "0",
	mr = "0",
	className = "",
	width,
	...props
}: InputProps) => {

	const [ focused, setFocused, ] = useState(false);

	const style: CSSProperties = {
		marginTop: mt,
		marginBottom: mb,
		marginLeft: ml,
		marginRight: mr,
		width: width || "auto",
	};

	const classes = () =>
		[
			`input-wrapper`,
			`${className}`,
			focused ? "focus" : null,
			isSuccess && "success",
			isError && "error",
		]
			.filter((v) => v)
			.join(" ");

	const Icon = ( icon && icon in ICONS ? ICONS[icon] : Fragment ) as FunctionComponent;
	const onFocus = ( ) => setFocused(true);
	const onBlur = ( ) => setFocused(false);

	return (
		<div className={classes()} style={style}>
			{ iconPosition === "start" && <Icon {...iconProps} /> }
			<input
				type="text"
				value={value || ""}
				onChange={(e) => onChange(e.target.value)}
				placeholder={placeholder}
				disabled={disabled}
				className="input"
				onFocus={onFocus}
				onBlur={onBlur}
				{...props}
			/>
			{ iconPosition === "end" && <Icon {...iconProps} /> }
		</div>
	);
};
